import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";
import UtilsUrl from "../../utils/UtilsUrl";
import api from "./../api";

class PublicationService {
  //Afficher List Publications
  AfficherListPublications(idUser) {
    return api.get(
      UtilsUrl.marketingURL() + "/publication/getAll/" + getCurrentUserId()
    );
  }
  //Afficher List Objectifs
  AfficherListObjectifs() {
    return api.get(UtilsUrl.marketingURL() + "/publication/getObjectifs");
  }

  //Afficher List Types
  AfficherListTypes() {
    return api.get(UtilsUrl.marketingURL() + "/publication/getTypes");
  }

  //Afficher List CanalDiffusion
  AfficherListCanalDiffusion() {
    return api.get(UtilsUrl.marketingURL() + "/publication/getCanalDiffusions");
  }

  //Afficher List Statut
  AfficherListStatus() {
    return api.get(UtilsUrl.marketingURL() + "/publication/getStatus");
  }

  // Obtenir la liste des ID de photos dans une publication
  getPublicationPhotosId(id) {
    return api.get(UtilsUrl.marketingURL() + "/publication/ListImages/"+getCurrentUserId()+"/" + id);
  }

  // Afficher une image par son ID
  showImage(imageId) {
    return api
      .get(UtilsUrl.marketingURL() + "/publication/showImage/" + imageId, {
        responseType: "arraybuffer",
      })
      .then((response) => {
        const arrayBufferView = new Uint8Array(response.data);
        const blob = new Blob([arrayBufferView], {
          type: response.headers["content-type"],
        });
        const imageUrl = URL.createObjectURL(blob);
        return imageUrl;
      });
  }

  //ajouter Publication
  ajouterPublication(nouvellePublication, images) {
    const formData = new FormData();
    let idUser=getCurrentUserId();
    // formData.append("idUser", getCurrentUserId());
    formData.append("publication", JSON.stringify(nouvellePublication));

    for (let i = 0; i < images.length; i++) {
      formData.append("images", images[i]);
    }
    return api.post(UtilsUrl.marketingURL() + "/publication/Add/"+idUser, formData, {
      headers: {
        "Content-Type": "multipart/form-data", // Set the content type to multipart/form-data
      },
    });
  }

  //mettreAJour Publication
  mettreAJourPublication(updatedPublication, images, publicationId) {
    const formData = new FormData();
    formData.append("idUser", getCurrentUserId());
    formData.append("publication", JSON.stringify(updatedPublication));
    for (let i = 0; i < images.length; i++) {
      formData.append("images", images[i]);
    }
    return api.put(
      UtilsUrl.marketingURL() + "/publication/update/" + publicationId,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data", // Set the content type to multipart/form-data
        },
      }
    );
  }

  //supprimer Publication
  supprimerPublication(PublicationId) {
    return api.put(
      UtilsUrl.marketingURL() + "/publication/delete/" + PublicationId,
      {
        headers: {
          "Content-Type": "multipart/form-data", // Set the content type to multipart/form-data
        },
      }
    );
  }

  //get Publication By ID
  getPublicationByID(PublicationId) {
    return api.get(
      UtilsUrl.marketingURL() + "/publication/get/"+getCurrentUserId()+"/" + PublicationId
    );
  }

  //filtre
  getPublicationsByFiltre(
    idUser,
    nom,
    canalDiffusion,
    type,
    statut,
    startDate,
    endDate
  ) {
    return api.get(
      UtilsUrl.marketingURL() +
        "/publication/filtre/"+idUser+"?nom=" +
        nom +
        "&type=" +
        type +
        "&canalDiffusion=" +
        canalDiffusion +
        "&statut=" +
        statut +
        "&startDate=" +
        startDate +
        "&endDate=" +
        endDate
    );
  }

  //CSV Methodes
  ImporterCSV(file) {
    return api.post(UtilsUrl.marketingURL() + "/publication/importcsv", file);
  }

  Exportcsv(nom, canalDiffusion, type, startDate, endDate) {
    return api.get(
      UtilsUrl.marketingURL() +
        "/publication/exportcsv?nom=" +
        nom +
        "&type=" +
        type +
        "&canalDiffusion=" +
        canalDiffusion +
        "&startDate=" +
        startDate +
        "&endDate=" +
        endDate,
      {
        responseType: "blob",
      }
    );
  }
}

export default new PublicationService();
